import { FC, useContext } from "react";
import CollectionFilter from "../components/collection/CollectionFilter";
import CollectionTable from "../components/collection/CollectionTable";
import NavigationPanel from "../components/NavigationPanel";
import {
  GameMonthlyReportByGameServiceContext,
  GameMonthlyReportByGameServiceContextProvider,
} from "../contexts/services/summary/GameMonthlyReportByGameServiceContext";
import SessionVerifier from "../contexts/SessionContext";
import SummaryDashboard from "../components/SummaryDashboard";

const SummaryGameMonthlyByGameScreen: FC<any> = () => {
  const contextGameMonthlyByGame = useContext(
    GameMonthlyReportByGameServiceContext
  );

  return (
    <NavigationPanel>
      <div className="relative pt-6 mt-4">
        <CollectionFilter
          template={[
            {
              name: "ตั้งแต่วันที่",
              field: "month",
              placeholder: "วันเริ่มต้นที่ต้องการค้นหา",
              value: contextGameMonthlyByGame.query.month,
              type: "datetime",
            },
            {
              name: "ถึงวันที่",
              field: "year",
              placeholder: "วันสิ้นสุดที่ต้องการค้นหา",
              value: contextGameMonthlyByGame.query.year,
              type: "datetime",
            },
          ]}
          onUpdateFilter={(field: any, value: any) =>
            contextGameMonthlyByGame.setQuery(field, value)
          }
          onSearch={() => contextGameMonthlyByGame.onFetch()}
        />
        <SummaryDashboard />
        <CollectionTable
          texts={{
            title: "Game Monthly By Game",
            description: "Game Monthly By Game",
            buttonTextAdd: "สรุปผล",
            buttonTextEdit: "รายงานผลแต่ละ Agent",
          }}
          template={[
            { name: "เดือน", field: "month" },
            { name: "ปี", field: "year" },
          ]}
          collection={contextGameMonthlyByGame.collection.map((item: any) => ({
            ...item,
          }))}
        />
      </div>
    </NavigationPanel>
  );
};

const SummaryGameMonthlyByGameScreenHoc = (props: any) => {
  return (
    <SessionVerifier>
      <GameMonthlyReportByGameServiceContextProvider>
        <SummaryGameMonthlyByGameScreen {...props} />
      </GameMonthlyReportByGameServiceContextProvider>
    </SessionVerifier>
  );
};
export default SummaryGameMonthlyByGameScreenHoc;
